export const PlacementType = Object.freeze({
	contextMenu: 'IM_CONTEXT_MENU',
	navigation: 'IM_NAVIGATION',
	textarea: 'IM_TEXTAREA',
	sidebar: 'IM_SIDEBAR',
	smilesSelector: 'IM_SMILES_SELECTOR',
});